export const BorrowerAgreementFun = (borrowerAgreement: any) => {
  if (borrowerAgreement) {
    borrowerAgreement = borrowerAgreement.replace(/,/g, ";");
    return borrowerAgreement;
  }
  return "";
};
